export const PersianInformalWithoutEmoji = [
  {
    sentence:
      "بالاخره دوره {COURSE_TITLE} رو تو فرادرس تموم کردم و گواهینامه‌ام رو گرفتم!",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "خوشحالم که تونستم دوره {COURSE_TITLE} رو تو فرادرس بگذرونم و گواهینامه بگیرم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "به تازگی دوره {COURSE_TITLE} رو تو فرادرس گذروندم و گواهینامه‌ام رو هم گرفتم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "از اینکه دوره {COURSE_TITLE} رو تموم کردم و گواهینامه گرفتم، حسابی خوشحالم!",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "بالاخره تونستم دوره {COURSE_TITLE} رو تو فرادرس تموم کنم و گواهینامه بگیرم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "دوره {COURSE_TITLE} رو تو فرادرس گذروندم و گواهینامه گرفتم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "امروز گواهینامه دوره {COURSE_TITLE} رو تو فرادرس دریافت کردم!",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "تونستم با موفقیت دوره {COURSE_TITLE} رو تو فرادرس بگذرونم و گواهینامه بگیرم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "به تازگی دوره {COURSE_TITLE} رو تو فرادرس گذروندم و گواهینامه‌ام به دستم رسید!",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "بالاخره دوره {COURSE_TITLE} رو تموم کردم و گواهینامه‌ام رو گرفتم!",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "دوره {COURSE_TITLE} رو با موفقیت تو فرادرس گذروندم و گواهینامه‌ام رو گرفتم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "خیلی خوشحالم که دوره {COURSE_TITLE} رو در فرادرس گذروندم و گواهینامه دریافت کردم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "تازه دوره {COURSE_TITLE} رو تموم کردم و گواهینامه گرفتم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "بعد از دوره {COURSE_TITLE}، بالاخره گواهینامه‌ام رو دریافت کردم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "حسابی از دوره {COURSE_TITLE} تو فرادرس لذت بردم و گواهینامه‌ام رو گرفتم.",
    tone: "informal",
    course_title: true,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "بالاخره یکی از دوره‌های فرادرس رو تموم کردم و گواهینامه‌ام رو گرفتم!",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "خوشحالم که تونستم یکی از دوره‌های فرادرس رو بگذرونم و گواهینامه بگیرم.",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "به تازگی یکی از دوره‌های فرادرس رو گذروندم و گواهینامه‌ام رو هم گرفتم.",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "از اینکه دوره‌ای از فرادرس رو تموم کردم و گواهینامه گرفتم، حسابی خوشحالم!",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "بالاخره تونستم یکی از دوره‌های فرادرس رو تموم کنم و گواهینامه بگیرم.",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "یکی از دوره‌های فرادرس رو به پایان رسوندم و گواهینامه گرفتم.",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "امروز گواهینامه دوره‌ای رو که در فرادرس گذروندم، دریافت کردم!",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "تونستم با موفقیت یکی از دوره‌های فرادرس رو بگذرونم و گواهینامه بگیرم.",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "به تازگی یکی از دوره‌های فرادرس رو گذروندم و گواهینامه‌ام به دستم رسید!",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "یکی از دوره‌های فرادرس رو تموم کردم و گواهینامه‌ام رو گرفتم!",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "خوشحالم که یکی از دوره‌های فرادرس رو با موفقیت گذروندم و گواهینامه گرفتم.",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "بالاخره یکی از دوره‌های فرادرس رو گذروندم و گواهینامه گرفتم.",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "خیلی وقت بود دنبال تکمیل این دوره بودم و حالا گواهینامه گرفتم.",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence: "حسابی از دوره فرادرس لذت بردم و گواهینامه‌ام رو گرفتم.",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
  {
    sentence:
      "یکی از دوره‌های فرادرس رو تموم کردم و امروز گواهینامه‌ام به دستم رسید!",
    tone: "informal",
    course_title: false,
    lang: "fa",
    using_emoji: false,
  },
];
